import { confColor } from "@/lib/miscellaneous/confidence-color";
import { cn } from "@/lib/utils";
import getSymbolFromCurrency from "currency-symbol-map";

type Props = {
  value: number;
  currency: string;
  confidence?: number | null;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
};

export const CurrencyCell = ({
  value,
  currency,
  confidence,
  className,
}: Props) => {
  return (
    <div className={cn("flex justify-end", className)}>
      <span className={cn("rounded p-1", confColor(confidence))}>
        {`${getSymbolFromCurrency(currency) ?? ""} ${
          value?.toFixed(2)?.replace(".", ",") ?? ""
        }`}
      </span>
    </div>
  );
};
